var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { SteemTxUtils } from '@popup/steem/utils/steem-tx.utils';
import Logger from 'src/utils/logger.utils';
import { Asset as CommonAsset } from '@steempro/steem-keychain-commons';
/* istanbul ignore next */
const deposit = (amount, receiver, username, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([yield getDepositOperation(username, receiver, amount)], activeKey, false, options);
});
/* istanbul ignore next */
const withdraw = (amount, to, username, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return SteemTxUtils.sendOperation([yield getWithdrawOperation(username, to, amount)], activeKey, false, options);
});
/* istanbul ignore next */
const getWithdrawOperation = (from, to, amount) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        'transfer_from_savings',
        {
            amount: amount,
            from: from,
            memo: '',
            request_id: yield SavingsUtils.getRequestId(from),
            to,
        },
    ];
});
/* istanbul ignore next */
const getDepositOperation = (from, to, amount) => __awaiter(void 0, void 0, void 0, function* () {
    return [
        'transfer_to_savings',
        {
            amount: amount,
            from: from,
            memo: '',
            request_id: yield SavingsUtils.getRequestId(from),
            to,
        },
    ];
});
const getRequestId = (username) => __awaiter(void 0, void 0, void 0, function* () {
    const savings = yield SteemTxUtils.getData('condenser_api.get_savings_withdraw_from', [username]);
    return Math.max(...savings.map((e) => e.request_id), 0) + 1;
});
/* istanbul ignore next */
const getSavingsWithdrawals = (username) => __awaiter(void 0, void 0, void 0, function* () {
    return yield SteemTxUtils.getData('condenser_api.get_savings_withdraw_from', [
        username,
    ]);
});
/* istanbul ignore next */
const getCancelTransferFromSavingsOperation = (username, request_id) => {
    return [
        'cancel_transfer_from_savings',
        {
            from: username,
            request_id,
        },
    ];
};
/* istanbul ignore next */
const cancelCurrentWithdrawSaving = (username, request_id, activeKey, options) => __awaiter(void 0, void 0, void 0, function* () {
    return yield SteemTxUtils.sendOperation([SavingsUtils.getCancelTransferFromSavingsOperation(username, request_id)], activeKey, false, options);
});
/* istanbul ignore next */
const hasBalance = (balance, greaterOrEqualTo) => {
    return typeof balance === 'string'
        ? CommonAsset.fromString(balance).amount >= greaterOrEqualTo
        : balance.amount >= greaterOrEqualTo;
};
const claimSavings = (activeAccount, options) => __awaiter(void 0, void 0, void 0, function* () {
    const { sbd_balance, savings_sbd_balance } = activeAccount.account;
    const hasSbd = hasBalance(sbd_balance, 0.001);
    const hasSavings = hasBalance(savings_sbd_balance, 0.001);
    if (hasSbd) {
        return SavingsUtils.deposit('0.001 SBD', activeAccount.name, activeAccount.name, activeAccount.keys.active, options);
    }
    else if (hasSavings) {
        return SavingsUtils.withdraw('0.001 SBD', activeAccount.name, activeAccount.name, activeAccount.keys.active, options);
    }
    else {
        Logger.error(`@${activeAccount.name} has no SBD to deposit or savings to withdraw`);
        return false;
    }
});
export const SavingsUtils = {
    getWithdrawOperation,
    getDepositOperation,
    withdraw,
    deposit,
    getRequestId,
    hasBalance,
    claimSavings,
    getSavingsWithdrawals,
    getCancelTransferFromSavingsOperation,
    cancelCurrentWithdrawSaving,
};
